export default "__VITE_ASSET__40a868fe__"